module.exports = __webpack_public_path__ + "static/media/kanskje.a0198cf4.mp3";